import React from "react";
import { useLocation } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewJoinedGuestListPage from "../../components/JoinedGuestList/ViewJoinedGuestListPage";

const ViewJoinedGuest = () => {
  const location = useLocation();
  const guestListId = location.state?.guestListId;

  return (
    <>
      <MasterLayout>
        {guestListId ? (
          <Breadcrumb
            title2="Guest List"
            link2="/guestList"
            title3="View Guest List"
            link3={`/guestList/view-guestList/${guestListId}`}
            title="View Joined Guest List Detail"
          />
        ) : (
          <Breadcrumb
            title2="Joined Guest List"
            link2="/joinedGuest"
            title="View Joined Guest"
          />
        )}
        <ViewJoinedGuestListPage />
      </MasterLayout>
    </>
  );
};

export default ViewJoinedGuest;
